import React, { Component } from 'react';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import LibInfo from './pages/Home/LibInfo';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from './Config/FbConfig';

export default class Home extends Component {

    state = {
        progressValue: "0%",
        Datas: [],
        Loading: true
    }

    //Load Data Here
    async componentDidMount() {
        const docRef = doc(firestore, "Library", "ImportantNotification");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            var Data = []
            Object.entries(docSnap.data()).forEach(([key, value]) => {
                Data.push(Object.assign({ Id: key }, value))
            });
            this.setState({
                Datas: Data,
                Loading: false
            })
        } else {
            this.setState({
                Datas: "NO_999",
                Loading: false
            })
        }
    }

    render() {
        return (
            <div>
                {/* Header */}
                <Header />

                {/*Notification*/}
                <div className="progress" style={{ height: "0.3rem", marginBottom: "0.25rem" }}><div className="progress-bar bg-warning" role="progressbar" style={{ width: "100%" }}></div></div>
                <marquee class="example1" direction="left" scrollamount="5" behavior="scroll">
                    {
                        this.state.Datas.length === 0 ? "Loading..." :
                            this.state.Datas === "NO_999" ? "No Data" :
                                this.state.Datas.map((data, i) => (
                                    <a key={i} target="_blank" href={data.Content}>{data.Header}&nbsp;&nbsp;</a>
                                ))
                    }
                </marquee>
                <div className="progress" style={{ height: "0.3rem", marginTop: "0.25rem" }}><div className="progress-bar bg-warning" role="progressbar" style={{ width: "100%" }}></div></div>

                <LibInfo />

                {/* Footer */}
                <Footer />
            </div>
        )
    }
}
